import { useState } from 'react';
import axios from 'axios';
import { MessageCircle, Mail, Clock } from 'lucide-react';
import { toast } from 'sonner';
import { Link } from 'react-router-dom';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Contatti() {
  const [form, setForm] = useState({ nome: '', email: '', messaggio: '' });
  const submit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/contact`, form);
      toast.success('Messaggio inviato. Ti rispondiamo entro 24 ore.');
      setForm({ nome: '', email: '', messaggio: '' });
    } catch { toast.error('Errore invio'); }
  };
  return (
    <main data-testid="contatti-page" className="container-essenya py-16">
      <div className="text-eyebrow mb-3">Contatti</div>
      <h1 className="font-display text-4xl md:text-5xl mb-3">Siamo qui per aiutarti</h1>
      <p className="text-essenya-text text-lg mb-12 max-w-2xl">Scrivici per qualsiasi domanda su prodotti, ordini o assistenza. Ti rispondiamo entro 24 ore.</p>
      <div className="grid md:grid-cols-[1fr_300px] gap-12">
        <form onSubmit={submit} className="space-y-4 max-w-xl" data-testid="contact-form">
          <input value={form.nome} onChange={e => setForm({ ...form, nome: e.target.value })} required placeholder="Nome" data-testid="contact-nome" className="w-full bg-white border border-essenya-border rounded-lg px-4 py-3 outline-none focus:border-essenya-ink" />
          <input type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required placeholder="Email" data-testid="contact-email" className="w-full bg-white border border-essenya-border rounded-lg px-4 py-3 outline-none focus:border-essenya-ink" />
          <textarea value={form.messaggio} onChange={e => setForm({ ...form, messaggio: e.target.value })} required rows={5} placeholder="Messaggio" data-testid="contact-messaggio" className="w-full bg-white border border-essenya-border rounded-lg px-4 py-3 outline-none focus:border-essenya-ink resize-none" />
          <button type="submit" data-testid="contact-submit" className="btn-primary">Invia messaggio</button>
        </form>
        <aside className="space-y-5 text-sm">
          <div className="flex gap-3"><Mail size={18} strokeWidth={1.5} /><div><p className="font-medium">Email</p><a href="mailto:info@essenya.it" className="text-essenya-text hover:text-essenya-ink transition-colors" data-testid="contatti-email">info@essenya.it</a></div></div>
          <div className="flex gap-3"><MessageCircle size={18} strokeWidth={1.5} /><div><p className="font-medium">WhatsApp</p><p className="text-essenya-text">+39 000 000 000</p></div></div>
          <div className="flex gap-3"><Clock size={18} strokeWidth={1.5} /><div><p className="font-medium">Tempi di risposta</p><p className="text-essenya-text">Entro 24 ore (lun-ven)</p></div></div>
          <div className="pt-4 border-t border-essenya-border space-y-2">
            <Link to="/faq" className="block text-sm underline">Vai alle FAQ</Link>
            <Link to="/tracking" className="block text-sm underline">Traccia un ordine</Link>
          </div>
        </aside>
      </div>
    </main>
  );
}
